







import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CustomBaseLabel extends Vue {
  @Prop({ default: "" }) title?: string;
  @Prop({ default: "" }) value?: string;
}
